import React, { useEffect, useState } from "react";
import "./App.css";

type Theme = "light" | "dark";

const getPreferredTheme = (): Theme => {
  if (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: light)").matches
  ) {
    return "light";
  }
  return "dark";
};

function App() {
  const [theme, setTheme] = useState<Theme>(getPreferredTheme);

  useEffect(() => {
    document.body.setAttribute("data-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <div className="App">
      <main className="content">
        <div className="card fade-in">
          <div className="card-header">
            <div className="brand">Nereia-Coatings</div>
            <button className="theme-toggle" onClick={toggleTheme}>
              {theme === "dark" ? "Light mode" : "Dark mode"}
            </button>
          </div>

          <p className="subtitle">
            The sustainable antifouling solution shipping has been waiting for
          </p>

          <div className="founders">
            <div>
              <p className="name">Julia Denkmayr</p>
              <p className="role">CEO / Co-Founder</p>
              <a href="mailto:julia@nereia-coatings.com">
                julia@nereia-coatings.com
              </a>
            </div>

            <div>
              <p className="name">Dr. Rimah Darawish Ph.D.</p>
              <p className="role">CTO / Co-Founder</p>
              <a href="mailto:rimah@nereia-coatings.com">
                rimah@nereia-coatings.com
              </a>
            </div>
          </div>
        </div>
      </main>

      <footer className="footer">
        <span>
          © {new Date().getFullYear()} Nereia-Coatings. All Rights Reserved.
        </span>
        <span className="footer-links">
          <a href="#imprint">Imprint</a>
          <span>·</span>
          <a href="#privacy">Privacy Policy</a>
        </span>
      </footer>
    </div>
  );
}

export default App;
